import axios from "../../../../../../api/axiosInstance";
import { FetchProductStoreProductResponse } from "./types";

export const fetchProductStoreProduct = async (
  id: string,
): Promise<FetchProductStoreProductResponse> => {
  const response = await axios.get<FetchProductStoreProductResponse>(
    `/api/private/product-store/products/${id}`,
  );
  return response.data;
};
